export function Arrow({
  className = '',
  style = undefined,
  color = 'white'
}) {
  return (
    <div className={`icon ${className}`} style={style}>
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 1.06133L1.06133 0L10.4981 9.4368V4.49061H12V10.7484C12 11.4393 11.4393 12 10.7484 12H4.49061V10.4981H9.4368L0 1.06133Z" fill={color}/>
      </svg>
    </div>
  )
}
